<div class="flex h-full w-full flex-col gap-1 py-5">
  @if (!!member().fullName) {
    <div class="flex gap-2">
      <span class="text-gray-2">ПІБ</span>
      <span class="flex-1 text-end">{{ member().fullName }}</span>
    </div>
  }
  @if (!!member().phoneNumber) {
    <div class="flex gap-2">
      <span class="text-gray-2">Телефон</span>
      <span class="flex-1 text-end">{{ member().phoneNumber }}</span>
    </div>
  }
  @if (!!member().email) {
    <div class="flex gap-2">
      <span class="text-gray-2">Пошта</span>
      <span class="flex-1 text-end">{{ member().email }}</span>
    </div>
  }
  @if (!!member().birthDate) {
    <div class="flex gap-2">
      <span class="text-gray-2">Дата народження</span>
      <span class="flex-1 text-end">{{ formatDate(member().birthDate) }}</span>
    </div>
  }
  @if (!!member().doctorName) {
    <div class="flex gap-2">
      <span class="text-gray-2">Лікар</span>
      <span class="flex-1 text-end">{{ member().doctorName }}</span>
    </div>
  }

  @if (!!memberContracts().length) {
    <shared-contract-item
      [type]="'list-items'"
      [contracts]="memberContracts()"
    ></shared-contract-item>
  }

  <div class="p-3">
    <mat-divider></mat-divider>
  </div>

  @if (chatState.features().showHealthCheckScheduler) {
    <div class="flex flex-col gap-3">
      <members-health-status-check-scheduler [userId]="member().userId"></members-health-status-check-scheduler>
    </div>

    <div class="p-3">
      <mat-divider></mat-divider>
    </div>
  }

  <div class="flex flex-col gap-4">
    <h4>{{ "memberComments.heading" | translate }}</h4>
    <members-comments-list [memberId]="member().id"></members-comments-list>
  </div>
</div>
